<app-dialog class="confirm-dialog">
  <img
    alt="alert icon"
    class="confirm-dialog__icon"
    [src]="iconByType[data.type]"
  />

  <div class="confirm-dialog__content">
    <h2 class="confirm-dialog__title">{{ data.title }}</h2>
    @if (data.message) {
      <p class="confirm-dialog__message">{{ data.message }}</p>
    }
  </div>

  @if (acceptVisible || rejectVisible) {
    <footer class="confirm-dialog__footer">
      @if (rejectVisible) {
        <button
          app-button
          class="confirm-dialog__button"
          [size]="data.rejectButtonProps?.size || 'large'"
          [variant]="data.rejectButtonProps?.variant || 'secondary'"
          (click)="reject()"
        >
          {{ data.rejectButtonProps?.label || 'Cancel' }}
        </button>
      }
      @if (acceptVisible) {
        <button
          app-button
          class="confirm-dialog__button"
          [size]="data.acceptButtonProps?.size || 'large'"
          [variant]="data.acceptButtonProps?.variant || 'primary'"
          (click)="accept()"
        >
          {{ data.acceptButtonProps?.label || 'Accept' }}
        </button>
      }
    </footer>
  }
</app-dialog>
